import { Link } from 'react-router-dom';
import { Trophy, Award, PartyPopper } from 'lucide-react';

// Badge icon mapping
const BADGE_ICONS = {
  'Founding Diver': '🏆',
  'Dive Explorer': '🗺️',
  'Dive Legend': '⭐',
  'Dive Connoisseur': '👑',
  'Friend of Tilted': '🤝',
  'Tilted Ambassador': '📣',
  'Word Spreader': '📢',
  'Buzz Builder': '🐝',
  'Dive Ambassador': '🎖️',
  'Tilted Influencer': '👑',
  'Dive Scout': '🔍',
  'Dive Finder': '🗺️'
};

export function BadgeFeedItem({ item }) {
  const timeAgo = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    
    if (seconds < 60) return 'Just now';
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
    return date.toLocaleDateString();
  };

  const badgeIcon = BADGE_ICONS[item.badge_name] || '🏅';

  return (
    <div className="bg-gradient-to-br from-dive-dark to-dive-darker border-2 border-amber-500/30 rounded-xl overflow-hidden">
      {/* Celebratory Header */}
      <div className="bg-gradient-to-r from-amber-500/20 via-yellow-500/10 to-amber-500/20 px-4 py-3 border-b border-amber-500/20">
        <div className="flex items-center gap-2 text-amber-400 text-sm font-medium">
          <PartyPopper className="w-4 h-4" />
          <span>Badge Earned!</span>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <div className="flex items-start gap-3">
          {/* User Avatar */}
          <Link to={`/social/${item.user_id}`} className="flex-shrink-0">
            {item.avatar_url ? (
              <img
                src={item.avatar_url}
                alt={item.display_name}
                className="w-10 h-10 rounded-full object-cover border-2 border-amber-500/50"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center border-2 border-amber-500/50">
                <span className="text-amber-400 font-medium">
                  {(item.display_name || 'U').charAt(0).toUpperCase()}
                </span>
              </div>
            )}
          </Link>

          {/* Text Content */}
          <div className="flex-1 min-w-0">
            <p className="text-white">
              <Link 
                to={`/social/${item.user_id}`} 
                className="font-medium hover:text-amber-400 transition-colors"
              >
                {item.display_name || item.username}
              </Link>
              <span className="text-gray-400"> earned a badge</span>
            </p>
            <p className="text-gray-500 text-xs mt-0.5">
              {timeAgo(item.earned_at)}
            </p>
          </div>
        </div>

        {/* Badge Display */}
        <div className="mt-4 bg-dive-darker border border-amber-500/30 rounded-xl p-4 text-center">
          {/* Badge Icon */}
          <div className="text-5xl mb-2 animate-pulse">
            {badgeIcon}
          </div>
          
          {/* Badge Name */}
          <h3 className="text-xl font-bold text-amber-400 mb-1">
            {item.badge_name}
          </h3>
          
          {/* Badge Description */}
          <p className="text-gray-400 text-sm">
            {item.badge_description}
          </p>
        </div>

        {/* Encourage Action */}
        <div className="mt-3 text-center">
          <Link 
            to={`/social/${item.user_id}`}
            className="text-sm text-amber-400 hover:underline"
          >
            View {item.display_name}'s profile →
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BadgeFeedItem;

